export const chartPageStartYear = 2021
